// src/app/services/barcode/barcode.component.ts
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Code128Service } from './code128.service';

@Component({
  selector: 'app-newbarcode',
  template: `
    <div class="newbarcode-container" [style.text-align]="textAlign">
      <div [innerHTML]="safeSvg"></div>
    </div>
  `,
  styles: [`
    .barcode-container {
      display: inline-block;
      padding: 10px;
      background: white;
    }
  `]
})
export class NewBarcodeComponent implements OnChanges {
  @Input() value: string = '';
  @Input() width: number = 2;
  @Input() height: number = 100;
  @Input() displayValue: boolean = true;
  @Input() fontSize: number = 20;
  @Input() textAlign: string = 'center';
  @Input() margin: number = 10;

  safeSvg: SafeHtml = '';

  constructor(
    private code128Service: Code128Service,
    private sanitizer: DomSanitizer
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] || changes['width'] || changes['height']) {
      this.generateBarcode();
    }
  }

  ngOnInit(): void {
    this.generateBarcode();
  }

  private generateBarcode(): void {
    if (this.value) {
        // console.log("this.value : ", this.value)
      try {
        const svg = this.code128Service.toSVG(this.value, {
          width: this.width,
          height: this.height,
          displayValue: this.displayValue,
          fontSize: this.fontSize,
          textAlign: this.textAlign,
          margin: this.margin
        });
        this.safeSvg = this.sanitizer.bypassSecurityTrustHtml(svg);
      } catch (error) {
        console.error('Erreur génération barcode:', error);
        this.safeSvg = '';
      }
    }
  }

  // Méthode pour télécharger
  download(filename?: string): void {
    const svg = this.code128Service.toSVG(this.value, {
      width: this.width,
      height: this.height,
      displayValue: this.displayValue
    });
    
    const blob = new Blob([svg], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || `barcode-${this.value}.svg`;
    link.click();
    URL.revokeObjectURL(url);
  }
}
